<script setup>
import { computed } from 'vue';

const emit = defineEmits(['update:checked']);

const props = defineProps({
    checked: {
        type: [Array, Boolean],
        required: true,
    },
    value: {
        default: null,
    },
    type: {
        type: String,
        default: 'checkbox',
    }
});

const proxyChecked = computed({
    get() {
        return props.checked;
    },

    set(val) {
        emit('update:checked', val);
    },
});
</script>

<template>
    <input
        :type="type"
        :value="value"
        v-model="proxyChecked"
        class="rounded dark:bg-transparent border-gray-600 dark:border-gray-300 text-gray-800 shadow-sm focus:ring-gray-900 dark:focus:ring-gray-900 dark:focus:ring-offset-gray-700"
    />
</template>
